<template>
  <div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <div class="columns is-multiline">
      <div class="column is-9">
        <div class="box">
          <admin-box-item title="이벤트 게시글 등록/수정">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="이벤트 게시글 노출기간">
                  <div class="flex" style="flex-wrap:wrap">
                    <admin-date-picker
                      :data="event.start_date"
                      @setDate="selDateMin"></admin-date-picker>
                    <div class="lp-dating">&#126;</div>
                    <admin-date-picker
                          :data="event.end_date"
                          @setDate="selDateMax"></admin-date-picker>
                  </div>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="게시물 노출 여부" tip="게시글 노출 기간과 무관하게 노출/비노출을 설정할 수 있습니다.">
                  <lp-radio :val="event.enable_post"
                            value_name="value"
                            label_name="label"
                            :data="[{label:'노출',value:true}, {label:'비노출', value:false}]"
                            @onSelect="onSelectedPostState"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="노출 우선순위" tip="숫자가 낮을 수록 우선순위가 높게 책정되어 먼저 표시되며, 노출 우선순위가 동일한 경우 최신등록순으로 표시됩니다.">
                  <input class="input"
                        :value="event.priority"
                        @input="e => event.priority = e.target.value"
                        placeholder="노출 우선순위를 입력하세요. (0~99)"
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="제목*">
                  <input class="input"
                        :value="event.title"
                        @input="e => event.title = e.target.value"
                        placeholder="제목을 입력하세요."
                        type="text">
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="내용*">
                  <lp-editor :text.sync="event.content"></lp-editor>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="배너 이미지">
                  <input-img :url.sync="event.img"></input-img>
                </admin-form-item>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="$route.query.id">
          <admin-box-item title="이벤트 댓글 등록">
            <!-- 댓글 목록 -->
            <div>
              <div class="comment-sub-title">
                댓글 목록 ({{ commentsArr.length }})
                <i v-if="isComment===false" @click="isComment=true" class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                <i v-if="isComment===true" @click="isComment=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>
              </div>
              <div style="padding:12px">
                <div v-if="isComment===true" v-for="(item, idx) in commentsArr" :key="'comments'+idx" style="margin-top: 12px;">
                  <div v-if="idx!==0" style="margin: 15px 0; width: 100%; height: 1px; background: #ddd;"></div>
                  <div style="display:flex; font-size: .9rem; color: #555;">
                    <div style="width: 82%;">
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성자</div>
                        <div>{{ item.display_name }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성일</div>
                        <div>{{ item.created_time }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성내용</div>
                        <div>{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="buttons" v-if="!item.is_deleted">
                      <button @click="clickUpdate(item)" class="button" style="padding: 6px 10px;">수정</button>
                      <button @click="clickDelete(item)" class="button is-danger" style="padding: 6px 10px;">삭제</button>
                    </div>
                    <div v-else>삭제된 댓글입니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 댓글 작성 -->
            <div>
              <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
              <admin-form-item label="작성 내용">
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important;"
                            @click="clickCommentsReg">등록</button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="isInternalPlugin('point_coupon')">
          <admin-box-item title="다운로드 쿠폰 등록">
            <div class="columns is-multiline">
              <div class="column is-full">
                <button class="button is-primary"
                        @click="$modal.show('couponListModal')">쿠폰 검색
                </button>

                <button class="button"
                        style="margin-left:8px"
                        @click="deleteCouponItem" v-if="couponTable.length>0">전체 삭제
                </button>
                <div style="overflow-x: auto;margin-top:16px" v-if="couponTable.length>0">
                  <div style="min-width:700px">
                    <table class="table">
                      <thead>
                      <tr>
                        <th style="width: 40px;">id</th>
                        <th style="width: 120px;">등록일</th>
                        <th style="width: 100px;">쿠폰명</th>
                        <th style="width: 120px;">다운로드 가능 기간</th>
                        <th style="width: 40px;">상태</th>
                        <th style="width: 120px;">할인 부담 유형</th>
                        <th style="width: 60px;">할인</th>
                        <th style="width: 100px;">삭제</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item,idx) in couponTable" :key="'item'+idx" class="lp-row many-field-tr">
                        <td>{{ item.id }}</td>
                        <td>{{ item.created_time }}</td>
                        <td>{{ item.name }}</td>
                        <td>
                          <div>{{ downloadPeriod(item) }}</div>
                        </td>
                        <td>
                          <div v-if="item.activate">발행중</div>
                          <div v-else>발행중지</div>
                        </td>
                        <td>
                          <div v-if="item.burden_type===0">플랫폼 전체 부담</div>
                          <div v-else-if="item.burden_type===1">플랫폼+파트너사 함께 부담</div>
                          <div v-else-if="item.burden_type===2">파트너 자체 발행</div>
                        </td>
                        <td>
                          <!-- 할인율 -->
                          <div v-if="item.discount_type===0">
                            {{ item.discount_rate }} %
                          </div>
                          <!-- 할인 금액 -->
                          <div v-if="item.discount_type===1">
                            {{ item.discount_price }} 원
                          </div>
                        </td>
                        <td>
                          <button class="button is-danger" @click="deleteCouponItem(idx)">삭제</button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>

    <!-- 저장 -->
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="done">저장하기</button>
    </div>

    <modal name="couponListModal" :adaptive="true" :width="900" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <download-coupon-list @tableItems="couponItems"></download-coupon-list>
      </div>
    </modal>

  </div>
</template>

<script>
import AdminBoxItem from "../../module/admin/AdminBoxItem";
import AdminFormItem from "../../module/admin/AdminFormItem";
import AdminDatePicker from "../../module/admin/AdminDatePicker";
import InputImg from "../../module/common/InputImg";
import LpRadio from "../../module/common/LpRadio";
import CreateMixin from "@/mixins/CreateMixin"
import DownloadCouponList from "./component/DownloadCouponList";


export default {
  layout: "Main",
  components: {
    DownloadCouponList,
    LpRadio,
    AdminDatePicker,
    AdminFormItem,
    AdminBoxItem,
    InputImg
  },
  mixins: [
    CreateMixin
  ],
  created() {

    // 새로 등록
    if ( this.$route.query.id === undefined ) {
      /*this.event.start_date = this.resetNewDate('start');
      this.event.end_date = this.resetNewDate('end');
      this.event.username = this.$store.getters.admin.username;*/
    }
    // 라우팅
    else {
      this.getData();
      this.getComment();
      this.event.start_date = this.convertNewDate(this.event.start_date);
      this.event.end_date = this.convertNewDate(this.event.end_date);
    }
  },
  data() {
    return {
      event: {
        id: 0,
        start_date: '',
        end_date: '',
        // date: {
        //   min: "2017-01-01",
        //   max: "2099-12-31"
        // },
        priority: 99,
        title: "",
        content: "",
        img: "",
        enable_post: true,
        coupon_list: []
      },
      isComment: false, // 댓글 목록 fold/unfold
      // 댓글 목록
      commentsArr: [],
      // 댓글 작성
      comments: {
        id: "", // 상품문의상세 게시글 id
        content: "",
        /*writer: "",
        writer_type: "",
        writer_name: "",
        writer_username: "",
        date: "",
        lock: false // 비밀댓글 여부*/
      },
      // 댓글 작성자 드롭다운 Array
      commentsWriterArr: [],
      couponTable: [],
    };
  },
  methods: {
    // 게시판 노출 여부
    onSelectedPostState(val) {
      this.event.enable_post = val;
    },
    getData() {
      this.$axios.get(this.getUrl('board/event/' + this.$route.query.id))
      .then(res => {
        if(res.status===200) {
          this.event = res.data;

          let couponTable = [];
          this.event.coupon_list.forEach(coupon_id => {
            this.$axios.get(this.getUrl(`coupon/${coupon_id}`)).then(res=>{
              couponTable.push(res.data);
            })
          })
          this.couponTable = couponTable;
        }
      });
    },
    getComment() {
      this.$axios.get(this.getUrl('board/event/' + this.$route.query.id + '/comment'))
        .then(res=>{
          this.commentsArr = res.data.data;
        })
    },
    // 삭제
    clickDelete(item) {
      this.$axios.delete(this.getUrl('board/event/' + this.$route.query.id + '/comment/' + item.id))
        .then(res=>{
          if(res.status===200){
            this.toast('삭제되었습니다.');
            this.getComment();

            this.comments = {
              id: "",
              content: ""
            }
          }
      })

    },
    // 수정
    clickUpdate(item) {
      this.comments.id = item.id;
      this.comments.content = item.content;

      // this.comments.writer = arr.writer;
      // this.comments.writer_type = arr.writer_type;
      // this.comments.writer_name = arr.writer_name;
      // this.comments.writer_username = arr.writer_username;
      // this.comments.lock = arr.lock;
      // this.comments.date = arr.date;

    },
    // 댓글 등록
    clickCommentsReg() {
      if(!this.comments.id){
        this.$axios.post(this.getUrl('board/event/'+this.$route.query.id+'/comment'), {
          content: this.comments.content
        }).then(res=>{
          if(res.status===200){
            this.getComment();
            this.comments = {
              id: '',
              content: ''
            }
            if(!this.isComment){
              this.isComment = true;
            }
          }
        })
      }
      else{
        this.$axios.patch(this.getUrl('board/event/'+this.$route.query.id+'/comment/'+this.comments.id), {
          content: this.comments.content
        }).then(res=>{
          if(res.status===200){
            this.getComment();
            this.comments = {
              id: '',
              content: ''
            }
          }
        })
      }
    },
    // 뒤로가기 (등록 취소)
    clickBack() {
      this.$router.back();
    },
    // 댓글 작성자 선택
    selectCommentsWriter(item) {
      this.comments.writer = item.name + `(${item.username})`;
      this.comments.writer_type = item.type;
      this.comments.writer_name = item.name;
      this.comments.writer_username = item.username;
    },
    selDateMin(val) {
      this.event.start_date = val;
    },
    selDateMax(val) {
      this.event.end_date = val;
    },
    priorityKeyUp(value) {
      this.event.priority = value;
    },
    done() {
      let err = '';
      if ( !this.event.title ) err = '제목을 입력하세요.';
      else if( !this.event.content ) err= '내용을 입력하세요.';

      if ( err ) {
        this.toast(err);
        return;
      }

      let value = this.cloneItem(this.event);
      if(!value.start_date){
        value.start_date = '1111-01-01';
      }
      if(!value.end_date){
        value.end_date = '9999-01-01';
      }

      if(!this.$route.query.id){
        this.$axios.post(this.getUrl('board/event'), value).then(res=>{
          if(res.status===200){
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('event'));
          }
        })
      }
      else {
        this.$axios.patch(this.getUrl('board/event/'+this.$route.query.id), value).then(res=>{
          if(res.status===200){
            this.toast('등록되었습니다.');
            this.$router.replace(this.getPath('event'));
          }
        })
      }
    },
    couponItems(res) {
      for (let i = 0; i < res.id_list.length; i++) {
        if (this.event.coupon_list.includes(res.id_list[i]) === false) {
          this.event.coupon_list.push(res.id_list[i]);
          this.couponTable.push(res.tableItems[i]);
        }
      }
      this.$modal.hide('couponListModal');
    },
    downloadPeriod(item) {
      if(item.download_start && item.download_end) {
        return `${item.download_start} ~ ${item.download_end}`;
      }
      else if(item.download_start) {
        return `${item.download_start} ~`;
      }
      else if(item.download_end) {
        return `~${item.download_end}`;
      }
      else {
        return '';
      }
    },
    deleteCouponItem(idx) {
      if (idx >= 0) {
        removeIndex(this.couponTable, idx);
        removeIndex(this.event.coupon_list, idx);
      } else {
        this.couponTable = [];
        this.event.coupon_list = [];
      }
    }
  }
};
</script>

<style lang="stylus" type="stylus" scoped>
////@import '~assets/css/reset';
@import '~assets/css/lp_main';

.comment-sub-title {
  background: #ddd;
  color: #333;
  padding: 8px 16px;
  font-size: 0.95rem;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
}

.event-comment-content {
  padding: 20px;
  font-size: 0.95rem;
  color: #222;
  border-radius: 3px;
  border: none;
  background-color: #f2f7f8;
  display: block;
  width: 100%;
  height: 120px;
}

.btn-add-img {
  margin: 0 8px 8px 0;
  background: #f2f7f8;
  width: 80px;
  height: 80px;
  text-align: center;
}

.btn-add-img i {
  font-size: 3rem;
  line-height: 80px;
  color: #555;
}
</style>
